import dayjs from "dayjs";

import { formatISOShort } from "./date";

export interface HebergementPeriodeDto {
  dateDebut?: string | Date | null;
  dateFin?: string | Date | null;
}

export function isSejourComplet(
  hebergements: HebergementPeriodeDto[],
  dateDebut: string | Date | null,
  dateFin: string | Date | null,
): boolean {
  if (hebergements.length === 0) {
    return false;
  }

  const dateDebutSejour = formatISOShort(dateDebut);
  const dateFinSejour = formatISOShort(dateFin);
  if (!dateDebutSejour || !dateFinSejour) {
    return false;
  }

  let previous: { dateDebut: string; dateFin: string } | undefined = undefined;

  for (const hebergement of hebergements) {
    const hebergementDateDebut = formatISOShort(hebergement.dateDebut);
    const hebergementDateFin = formatISOShort(hebergement.dateFin);
    if (!hebergementDateDebut || !hebergementDateFin) {
      return false;
    }

    if (!previous) {
      if (hebergementDateDebut !== dateDebutSejour) {
        return false;
      }
    } else {
      const lendemain = dayjs(previous.dateFin).add(1, "day");
      const isLendemain = hebergementDateDebut === formatISOShort(lendemain);
      const isLegacyContiguous = hebergementDateDebut === previous.dateFin;
      if (!isLendemain && !isLegacyContiguous) {
        return false;
      }
    }

    previous = { dateDebut: hebergementDateDebut, dateFin: hebergementDateFin };
  }

  return previous!.dateFin === dateFinSejour;
}
